import { useEffect, useState } from "react";

export const SelectField = (props) => {
  const { onChange, filter, field, options } = props;

  const [option, setOption] = useState({ id: 0, name: "Vyberte" });

  useEffect(() => {
    if (filter[field] && options.length !== 0) {
      setOption(options.find((item) => item.id == filter[field]));
    }
  }, [options]);

  return (
    <td role="cell" className="td-filter">
      <select className="table-filter-select" name={field} onChange={onChange}>
        <option value={option.id}>{option.name}</option>
        {options.map((item, key) => (
          <option
            key={key}
            className={item.id == option.id ? "hidden" : ""}
            value={item.id}
          >
            {item.name}
          </option>
        ))}
      </select>
    </td>
  );
};
